
export const parseSiFloat = num => {
  if (typeof num !== 'string' && typeof num !== 'number') return 0
  if (typeof num === 'number') num = num + ''
  if (num.includes(',')) {
    num = num.split(',').join('.')
  }
  num = parseFloat(num) + ''
  return num.split('.').join(',')
}

export const parseSiFloatFixed = (num, decimals) => {
  if (typeof num !== 'string' && typeof num !== 'number') return 0
  if (typeof num === 'number') num = num + ''
  if (num.includes(',')) {
    num = num.split(',').join('.')
  }
  num = parseFloat(num).toFixed(decimals)
  return num.split('.').join(',')
}

export const parseSiFloatMaxDec = (num, decimals) => {
  if (typeof num !== 'string' && typeof num !== 'number') return 0
  if (typeof num === 'number') num = num + ''
  if (num.includes(',')) {
    num = num.split(',').join('.')
  }
  num = parseFloat(num)
  num = hasMoreDecimals(num, decimals) ? num.toFixed(decimals) : num + ''
  return num.split('.').join(',')
}

export const siFloatToFloat = num => {
  if (typeof num !== 'string') return num
  return parseFloat(num.split(',').join('.'))
}

const hasMoreDecimals = (num, dec) => {
  const numString = num + ''
  if (!numString.includes('.')) return 0
  return numString.split('.')[1].length
}
